import moment from "moment";
import {AccountStatus, DisconnectionSource, WORKPLATFROMIDMAPPING} from "../constants/constants";

// to format num ex 12000 -> 12K
export const formatNumber = (num) => {
  function rnd(num, precision) {
    var prec = 10 ** precision;
    return Math.round(num * prec) / prec;
  }
  var abbRev = ["K", "M", "B"];
  var base = Math.floor(Math.log(Math.abs(num)) / Math.log(1000));
  var suffix = abbRev[Math.min(abbRev.length - 1, base - 1)];
  base = abbRev.indexOf(suffix) + 1;
  return suffix ? rnd(num / 1000 ** base, 2) + suffix : "" + num;
};

// convert time to hrs min
export const timeConvert = (time) => {
  let hours = Math.floor(time / 60);
  let minutes = time % 60;
  return Math.floor(hours) + " hrs " + Math.floor(minutes) + " mins ";
};

// returns boolean if image exists or not
export const isImageExist = async(url) => {
   return new Promise((resolve, reject) => {
    const img = new Image();
    img.src = url;
    
    img.onload = function() {
      resolve(true);
    };
  
    img.onerror = function() {
      reject(false);
    };
  });
};

// to calculate differnce b etween dates
export const calculateTotalDays = (firstDate) => {
let date = moment(firstDate);
let differenceInDays = moment().diff(date, 'days');
return differenceInDays < 1
    ? "Today"
    : differenceInDays < 2
    ? "1 day ago"
    : differenceInDays < 3
    ? "2 day ago"
    : differenceInDays < 4
    ? "3 day ago"
    : moment(firstDate).format("MMM DD, YYYY");
};
// moment(clientSecrets[0]?.created_at).format("MMM DD, YYYY")
// function to convert 2023-02-08T22:09:40.659106 data to Month in text just 3 letters Day, Year format
export const convertDate = (date) => {
  let d = new Date(date);
  let month = d.toLocaleString("default", { month: "short" });
  let day = d.getDate();
  let year = d.getFullYear();
  return month + " " + day + ", " + year;
};

//write a function to find latest date from array of dates
export const latestDate = (dates) => {
  const latest = new Date(Math.max.apply(null, dates));
  return latest;
};

export function getUserName(identityData) {
    if (!identityData) {
        return '';
    }
    const {work_platform: {id}} = identityData;
    return (WORKPLATFROMIDMAPPING[id] && WORKPLATFROMIDMAPPING[id].platformName.toLowerCase() === 'youtube') // for youtube profile name shown as username
        ? (identityData.platform_profile_name || '')
        : (identityData.platform_username || '');
}

export function checkRemoved(account) {
    return account?.status === AccountStatus.NOT_CONNECTED.key && account?.disconnection_source === DisconnectionSource.DEVELOPER_API;
}

